import React from 'react';
import createReactClass from 'create-react-class';
import Reflux from 'reflux';

import StoreProvider from 'injection/StoreProvider';

import { DocumentTitle, PageHeader } from 'components/common';
import { InputsList } from 'components/inputs';

const CurrentUserStore = StoreProvider.getStore('CurrentUser');
const InputStatesStore = StoreProvider.getStore('InputStates');

const InputsPage = createReactClass({
  displayName: 'InputsPage',
  mixins: [Reflux.connect(CurrentUserStore)],

  componentDidMount() {
    this.interval = setInterval(InputStatesStore.list, 2000);
  },

  componentWillUnmount() {
    clearInterval(this.interval);
  },

  render() {
    return (
      <DocumentTitle title="Inputs">
        <div>
          <PageHeader title="Inputs">
            <span>Graylog nodes accept data via inputs. Launch or terminate as many inputs as you want here.</span>
          </PageHeader>
          <InputsList permissions={this.state.currentUser.permissions} />
        </div>
      </DocumentTitle>
    );
  },
});

export default InputsPage;
